import React, { Component } from 'react';
import $ from 'jquery';
import AuthStorage from '../Utils/AuthStorage';
import * as constant from '../constant';
import { conectar } from '../Utils/LancamentoSignalR';
import { format, formatarComZero } from '../Utils/Helpers';
import { Link } from 'react-router-dom';
import * as api from '../Services/Service';
import { default as auth } from '../Utils/AuthStorage';

export default class AtendimentoCorretor extends Component {
  state = {
    atendimentos: [],
  };

  estruturarCard = ticket => ({
    ...ticket,
    data_inicio_atendimento: format.date(
      ticket.data_inicio_atendimento,
      'HH:mm'
    ),
    data_inicio_notificacao: ticket.data_inicio_notificacao
      ? format.date(ticket.data_inicio_notificacao, 'HH:mm')
      : null,
    mesa: {
      ...ticket.mesa,
      Numero: formatarComZero(ticket.mesa.numero),
    },
    prospecto: {
      ...ticket.prospecto,
      nome: ticket.prospecto.nome.split(/(\s).+\s/).join(''),
    },
  });

  async componentDidMount() {
    const env = AuthStorage.getEnv();
    const response = await api.consultarAtendimentoMesas(env);
    const atendimentos = response.map(ticket => this.estruturarCard(ticket));

    this.setState({ atendimentos });

    conectar({
      IniciarAtendimento: (data) => this.iniciarAtendimento(data),
      FinalizarAtendimento: (data) => this.finalizarAtendimento(data),
      ChamarCorretor: (data) => this.chamarCorretor(data),
      LoteReservado: (data) => this.reservouLote(data),
      RemoverChamarCorretor: (data) => this.removerItemDestaque(data),
    });
  }

  alertaSonoro(tipo) {
    let audio = $(
      tipo === 'iniciarAtendimento'
        ? '#audioNovoAtendimento'
        : '#audioChamarCorretor'
    );
    if (window.navigator) {
      navigator.vibrate(3000);
    }
    try {
      $(audio)[0].currentTime = 0;
      $(audio)[0].play();
    } catch (error) {
      console.error(error);
    }
  }

  removerItemDestaque = ticket => {
    let novoAtendimento = this.state.atendimentos.map(item => {
      if (item.codigo !== ticket.codigo) {
        return item;
      }
      return {
        ...item,
        iniciou_atendimento: false,
        data_inicio_notificacao: null,
        reservou: false,
      };
    });
    this.setState({ atendimentos: novoAtendimento });
  };

  iniciarAtendimento = ticket => {
    if (
      auth.isADM() ||
      (auth.isGerente() &&
        ticket.corretor.codigo_gerente === auth.getUser().usuario) ||
      (auth.isCorretor() && ticket.corretor.codigo === auth.getUser().usuario)
    ) {
      this.alertaSonoro('iniciarAtendimento');
      let atendimentos = [
        { ...this.estruturarCard(ticket), iniciou_atendimento: true },
        ...this.state.atendimentos,
      ];
      this.setState({ atendimentos });
      setTimeout(() => {
        this.removerItemDestaque(ticket);
      }, 10000);
    }
  };

  finalizarAtendimento = ticket => {
    let index = this.state.atendimentos.reduce((prev, curr, index) => {
      return curr.codigo === ticket.codigo ? index : prev;
    }, null);

    if (index === null) return;

    let atendimentos = [
      ...this.state.atendimentos.slice(0, index),
      ...this.state.atendimentos.slice(index + 1),
    ];
    this.setState({ atendimentos });
  };

  chamarCorretor = ticket => {
    this.alertaSonoro('chamarCorretor');
    const encontrou = this.state.atendimentos.some(item => item.codigo === ticket.codigo);
    if (encontrou) {
      const atendimentos = this.state.atendimentos.map(item => {
        if (item.codigo !== ticket.codigo) {
          return item;
        }
        return {
          ...item,
          status: 2,
          data_inicio_notificacao: format.date(new Date(), 'HH:mm'),
          corretor: { ...item.corretor, corretor_solicitado: true },
        };
      });
      this.setState({ atendimentos });
    } else {
      this.recarregarAtendimentos();
    }
  };

  recarregarAtendimentos = async () => {
    const env = AuthStorage.getEnv();
    const response = await api.consultarAtendimentoMesas(env);
    const atendimentos = response.map(ticket => this.estruturarCard(ticket));
    this.setState({ atendimentos });
  };

  reservouLote = ticket => {
    let atendimentos = this.state.atendimentos.map(item => {
      if (item.codigo !== ticket.codigo) {
        return item;
      }
      return {
        ...item,
        reservou: true,
      };
    });
    this.setState({ atendimentos });
    setTimeout(() => {
      this.removerItemDestaque(ticket);
    }, 7000);
  };

  render() {
    let { atendimentos } = this.state;
    const isCorretor = auth.isCorretor();

    atendimentos = atendimentos.sort(atendimento => {
      return atendimento.data_inicio_notificacao ||
        atendimento.iniciou_atendimento
        ? -1
        : 1;
    });

    return (
      <div className="SequentialTicket">
        <h5 className="w-100 text-center">Atendimentos ativos - Corretor</h5>
        <ul className="ticket-list">
          {atendimentos.map((ticket, index) => (
            <li
              className={`ticket ${(ticket.iniciou_atendimento && 'novo') ||
                (ticket.reservou && 'reservou') ||
                (ticket.data_inicio_notificacao &&
                  ticket.corretor.corretor_solicitado &&
                  'chamou')}`}
              key={index}
            >
              <div className="ticket__row ticket__mesa_descricao">
                <div className="ticket__mesa ticket__col">
                  <strong>{ticket.mesa.numero}</strong>
                </div>
                <div className="ticket__col ticket__descricao">
                  <div className="ticket__row">
                    <Link
                      className="ticket__nome"
                      to={`/prospectos/${ticket.prospecto.codigo}/dados-cliente/pessoais`}
                    >
                      {ticket.prospecto.nome}
                    </Link>
                  </div>
                  <div className="ticket__row ticket__data">
                    <span className="ticket__tipo">iniciou:</span>
                    <strong>{ticket.data_inicio_atendimento}</strong>
                    <span className="ticket__tipo">solicitado:</span>
                    <strong>
                      {ticket.data_inicio_notificacao
                        ? ticket.data_inicio_notificacao
                        : '--:--'}
                    </strong>
                  </div>
                </div>
              </div>
              {!isCorretor && (
                <div className="ticket__corretor">
                  <span className="ticket__tipo">corretor:</span>
                  <span className="ticket__nome__corretor">
                    {ticket.corretor.nome}
                  </span>
                </div>
              )}
            </li>
          ))}
        </ul>
        <audio style={{ display: 'none' }} id="audioChamarCorretor">
          <source src={constant.audio2} type="audio/ogg" />
        </audio>
        <audio style={{ display: 'none' }} id="audioNovoAtendimento">
          <source src={constant.audio3} type="audio/ogg" />
        </audio>
      </div>
    );
  }
}
